import { cronosClient } from "@/config/client"
import type { UserEvent, UserEventCategory } from "@/services/api/cronos/user/events/get-all"

export interface Body {
  title: string
  startDate: string
  endDate: string
  category: UserEventCategory
  recurringDays: number[]
  isBulkUpdate: boolean
}

interface Payload {
  eventId: string
  body: Body
  params: {
    returnStart: string
    returnEnd: string
    timeZone: string
  }
}

interface Response {
  description: UserEvent[]
}

export function update(payload: Payload) {
  const { body, params, eventId } = payload
  return cronosClient.put<Response, Body>(`/v1/user/events/${eventId}`, body, { params })
}
